import React, { Fragment, useState, useEffect } from "react";
import { Drawer, ANCHOR } from "baseui/drawer";
import { styled, useStyletron } from "baseui";
import CreateNewTemplateInfoView from "./CreateNewTemplateInfoView";
import CreateTemplateModelerInfoView from "./CreateTemplateModelerInfoView";
import { Button } from "baseui/button";
import ROUTES_PATH from "../../constants/RouteConstants";
import {ACCESS_TYPES} from "../../constants/AppEnums";
import { useHistory } from "react-router-dom";
import { createNewTemplate } from "../../redux/template/TemplateThunk";
import { connect } from "react-redux";
import { Spinner, SIZE } from "baseui/spinner";
import {randomString} from "../../helpers/StringHelpers";
import useToaster from "../../hooks/useToaster";
const positionBottomRightCss = {
  position: "absolute",
  bottom: "8px",
  right: "10px",
  width: "90px",
  height: '50px',
};

const positionBottomLeftCss = {
  position: "absolute",
  bottom: "8px",
  left: "10px",
  width: "90px",
  height: '50px',
};
function TemplateCreateNewView(props) {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(props.isOpen);
  const [currentStep, setCurrentStep] = useState(1);
  const [css, theme] = useStyletron();
  const [templateTitle, setTemplateTitle] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [templateAccess, setTemplateAccess] = useState(ACCESS_TYPES.PUBLIC);
  const [solver, setSolver] = useState("");
  const [modelerTitle, setmodelerTitle] = useState("");
  const [modelerDescription, setModelerDescription] = useState("");
  const [modelerAccess, setModelerAccess] = useState(ACCESS_TYPES.PUBLIC);
  const [templateImage, setTemplateImage] = useState(null);
  const [templateImageURL, setTemplateImageURL] = useState(null);
  const [modelerImage, setModelerImage] = useState(null);
  const [modelerImageURL, setModelerImageURL] = useState(null);
  const [templateTopics, setTemplateTopics] = useState([]);
  const [templateIndustries, setTemplateIndustries] = useState([]);
  const {isLoading, created} = props;
  useToaster(props.errorMessage)

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  function next() {
    setCurrentStep(2);
  }
  function previous() {
    setCurrentStep(1);
  }
  function handleCreateTemplate() {
    props.createNewTemplate({
      createdBy: props.userId,
      title: templateTitle,
      description: templateDescription,
      access: templateAccess,
      solver: solver[0].id,
      modelerTitle: modelerTitle,
      modelerDescription: modelerDescription,
      modelerAccess: modelerAccess,
      thumbnailImage: "thumbnailImage",
      modelerThumbnailImage: "modelerThumbnailImage",
      templateImageFile: templateImage,
      modelerImageFile: modelerImage,
      topics: templateTopics,
      industries: templateIndustries,
      published: false,
    });
  }
  useEffect(() => {
    if (!isLoading && created) {      
      history.push(
        `${ROUTES_PATH.templateEditor}${props.activeTemplate.id}/${ROUTES_PATH.templateParameter}`
      );
    }
  }, [isLoading, created]);
  return (
    <Fragment>
      <Drawer
        isOpen={isOpen}
        autoFocus
        anchor={ANCHOR.right}
        onClose={(closeSource) => {
          if (closeSource.closeSource === "closeButton") {
            setIsOpen(false);
            props.onClose();
          }
        }}
        overrides={{
          Close: {
            style: ({ $theme }) => ({
              ":hover": {
                backgroundColor: $theme.colors.buttonSecondaryHover,
                cursor: "pointer",
              },
            }),
          },
        }}
      >
        {currentStep === 1 && (
          <CreateNewTemplateInfoView
            title={templateTitle}
            solver={solver}
            description={templateDescription}
            access={templateAccess}  
            templateImage={templateImageURL}          
            onTemplateTitleChange={(value) => setTemplateTitle(value)}
            onSolverChange={(item) => setSolver(item)}
            onTemplateDescriptionChange={(value) => {
              setTemplateDescription(value);
            }}
            onTemplateAccessChanged={(value) => setTemplateAccess(value)}
            onTemplateTopicsChange={(value) => setTemplateTopics(value)}
            onTemplateIndustriesChange={(value) => setTemplateIndustries(value)}
            // onTemplateImageChange={(value) => {
            //   let fileUrl = URL.createObjectURL(value)
            //   setTemplateImageURL(fileUrl)
            //   setTemplateImage(value)
            // }}            
          />
        )}
        {currentStep === 2 && (
          <CreateTemplateModelerInfoView
            title={modelerTitle}
            description={modelerDescription}
            access={modelerAccess}  
            modelerImage={modelerImageURL}          
            onModelerTitleChange={(value) => setmodelerTitle(value)}
            onModelerDescriptionChange={(value) => {
              setModelerDescription(value);
            }}
            onModelerAccessChanged={(value) => setModelerAccess(value)}
            onModelerImageChange={(value) => {
              let fileUrl = URL.createObjectURL(value)
              setModelerImageURL(fileUrl)
              setModelerImage(value)
            }
            }
          />
        )}

        {currentStep === 1 ? (
          <Button className={css(positionBottomRightCss)} onClick={() => next()}>
            Next
          </Button>
        ) : (
          <div>
            <Button
              className={css(positionBottomLeftCss)}
              onClick={() => previous()}
            >
              Prvious
            </Button>
            <Button
              disabled={isLoading}
              className={css(positionBottomRightCss)}
              onClick={() => handleCreateTemplate()}
            >
              Create
            </Button>
          </div>
        )}
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.username,
    userId: state.user.userId,
    activeTemplate: state.template.activeTemplate,
    isLoading: state.template.isLoading,
    created : state.template.created,
    errorMessage: state.template.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createNewTemplate: (template) => {
      dispatch(createNewTemplate(template));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCreateNewView);
